import React from "react";
const Favourites =() =>{
    return(
       <div className="col-lg-8 col-xl-9">
  <div className="dashboard-header">
    <h3>Favourites</h3>
    <ul className="header-list-btns">
      <li>
        <div className="input-block dash-search-input">
          <input type="text" className="form-control" placeholder="Search" />
          <span className="search-icon"><i className="isax isax-search-normal" /></span>
        </div>
      </li>
    </ul>
  </div>
  {/* Favourites */}
  <div className="row">
    <div className="col-md-6 col-lg-4 d-flex">
      <div className="profile-widget patient-favour flex-fill">
        <div className="fav-head">
          {/* <a> */}<a href="#!"  className="fav-btn favourite-btn">
            <span className="favourite-icon favourite"><i className="isax isax-heart5" /></span>
          </a>
          <div className="doc-img">
            <a href="/">
              <img className="img-fluid" alt="User " src="assets/img/doctors/doctor-thumb-21.jpg" />
            </a>
          </div>
          <div className="pro-content">
            <h3 className="title">
              <a href="doctor-profile.html">Dr.Edalin Hendry</a> 
              <i className="isax isax-tick-circle5 verified" />
            </h3>
            <p className="speciality">MD - Cardiology</p>
            <div className="rating">
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <span className="d-inline-block average-rating">5.0</span>
            </div>
            <ul className="available-info">
              <li>
                <i className="isax isax-calendar5 me-1" /><span>Next Availability :</span> 23 Mar 2024
              </li>
              <li>
                <i className="isax isax-location5 me-1" /><span>Location :</span> Newyork, USA
              </li>
            </ul>
            <div className="last-book">
              <p>Last Book on 21 Jan 2023</p>
            </div>
          </div>
        </div>
        <div className="fav-footer">
          <div className="row row-sm">
            <div className="col-6">
              <a href="/" className="btn btn-md btn-light w-100">View Details</a>
            </div>
            <div className="col-6">
              <a href="/" className="btn btn-md btn-outline-primary w-100">Book Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-6 col-lg-4 d-flex">
      <div className="profile-widget patient-favour flex-fill">
        <div className="fav-head">
          {/* <a> */}<a href="#!"  className="fav-btn favourite-btn">
            <span className="favourite-icon favourite"><i className="isax isax-heart5" /></span>
          </a>
          <div className="doc-img">
            <a href="/">
              <img className="img-fluid" alt="User " src="assets/img/doctors/doctor-thumb-13.jpg" />
            </a>
          </div>
          <div className="pro-content">
            <h3 className="title">
              <a href="/">Dr.Shanta Nesmith</a> 
              <i className="isax isax-tick-circle5 verified" />
            </h3>
            <p className="speciality">DO -  Oncology</p>
            <div className="rating">
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star" />
              <span className="d-inline-block average-rating">(35)</span>
            </div>
            <ul className="available-info">
              <li>
                <i className="isax isax-calendar5 me-1" /><span>Next Availability :</span> 27 Mar 2024
              </li>
              <li>
                <i className="isax isax-location5 me-1" /><span>Location :</span> Los Angeles, USA
              </li>
            </ul>
            <div className="last-book">
              <p>Last Book on 18 Jan 2023</p>
            </div>
          </div>
        </div>
        <div className="fav-footer">
          <div className="row row-sm">
            <div className="col-6">
              <a href="/" className="btn btn-md btn-light w-100">View Profile</a>
            </div>
            <div className="col-6">
              <a href="/" className="btn btn-md btn-outline-primary w-100">Book Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-6 col-lg-4 d-flex">
      <div className="profile-widget patient-favour flex-fill">
        <div className="fav-head">
          {/* <a> */}<a href="#!"  className="fav-btn favourite-btn">
            <span className="favourite-icon favourite"><i className="isax isax-heart5" /></span>
          </a>
          <div className="doc-img">
            <button href="/">
              <img className="img-fluid" alt="User" src="assets/img/doctors/doctor-thumb-14.jpg" />
            </button>
          </div>
          <div className="pro-content">
            <h3 className="title">
              <a href="/">Dr.John Ewel</a> 
              <i className="isax isax-tick-circle5 verified" />
            </h3>
            <p className="speciality">MD - Orthopedics</p>
            <div className="rating">
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star" />
              <span className="d-inline-block average-rating">5.0</span>
            </div>
            <ul className="available-info">
              <li>
                <i className="isax isax-calendar5 me-1" /><span>Next Availability :</span> 02 Apr 2024
              </li>
              <li>
                <i className="isax isax-location5 me-1" /><span>Location :</span> Dallas, USA
              </li>
            </ul>
            <div className="last-book">
              <p>Last Book on 28 Jan 2023</p>
            </div>
          </div>
        </div>
        <div className="fav-footer">
          <div className="row row-sm">
            <div className="col-6">
              <a href="/" className="btn btn-md btn-light w-100">View Profile</a>
            </div>
            <div className="col-6">
              <a href="/" className="btn btn-md btn-outline-primary w-100">Book Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-6 col-lg-4 d-flex">
      <div className="profile-widget patient-favour flex-fill">
        <div className="fav-head">
          {/* <a> */}<a href="#!"  className="fav-btn favourite-btn">
            <span className="favourite-icon favourite"><i className="isax isax-heart5" /></span>
          </a>
          <div className="doc-img">
            <a href="/">
              <img className="img-fluid" alt="User" src="assets/img/doctors/doctor-thumb-15.jpg" />
            </a>
          </div>
          <div className="pro-content">
            <h3 className="title">
              <a href="/">Dr.Susan Fenimore</a> 
              <i className="isax isax-tick-circle5 verified" />
            </h3>
            <p className="speciality">DO - Dermatology</p>
            <div className="rating">
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star" />
              <span className="d-inline-block average-rating">4.0</span>
            </div>
            <ul className="available-info">
              <li>
                <i className="isax isax-calendar5 me-1" /><span>Next Availability :</span> 11 Apr 2024
              </li>
              <li>
                <i className="isax isax-location5 me-1" /><span>Location :</span> Chicago, USA
              </li>
            </ul>
            <div className="last-book">
              <p>Last Book on 08 Feb 2023</p>
            </div>
          </div>
        </div>
        <div className="fav-footer">
          <div className="row row-sm">
            <div className="col-6">
              <a href="/" className="btn btn-md btn-light w-100">View Profile</a>
            </div>
            <div className="col-6">
              <a href="/" className="btn btn-md btn-outline-primary w-100">Book Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-6 col-lg-4 d-flex">
      <div className="profile-widget patient-favour flex-fill">
        <div className="fav-head">
          {/* <a> */}<a href="#!"  className="fav-btn favourite-btn">
            <span className="favourite-icon favourite"><i className="isax isax-heart5" /></span>
          </a>
          <div className="doc-img">
            <a href="/">
              <img className="img-fluid" alt="User " src="assets/img/doctors/doctor-thumb-16.jpg" />
            </a>
          </div>
          <div className="pro-content">
            <h3 className="title">
              <a href="/">Dr.Juliet Rios</a> 
              <i className="isax isax-tick-circle5 verified" />
            </h3>
            <p className="speciality">MD - Neurology</p>
            <div className="rating">
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star" />
              <span className="d-inline-block average-rating">5.0</span>
            </div>
            <ul className="available-info">
              <li>
                <i className="isax isax-calendar5 me-1" /><span>Next Availability :</span>18 Apr 2024
              </li>
              <li>
                <i className="isax isax-location5 me-1" /><span>Location :</span> Detroit, USA
              </li>
            </ul>
            <div className="last-book">
              <p>Last Book on 16 Feb 2023</p>
            </div>
          </div>
        </div>
        <div className="fav-footer">
          <div className="row row-sm">
            <div className="col-6">
              <a href="/" className="btn btn-md btn-light w-100">View Profile</a>
            </div>
            <div className="col-6">
              <a href="/" className="btn btn-md btn-outline-primary w-100">Book Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-6 col-lg-4 d-flex">
      <div className="profile-widget patient-favour flex-fill">
        <div className="fav-head">
          {/* <a> */}<a href="#!"  className="fav-btn favourite-btn">
            <span className="favourite-icon favourite"><i className="isax isax-heart5" /></span>
          </a>
          <div className="doc-img">
            <a href="/">
              <img className="img-fluid" alt="User " src="assets/img/doctors/doctor-thumb-17.jpg" />
            </a>
          </div>
          <div className="pro-content">
            <h3 className="title">
              <a href="/">Dr.Joseph Engels</a> 
              <i className="isax isax-tick-circle5 verified" />
            </h3>
            <p className="speciality">MD - Pediatrics</p>
            <div className="rating">
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star" />
              <span className="d-inline-block average-rating">4.0</span>
            </div>
            <ul className="available-info">
              <li>
                <i className="isax isax-calendar5 me-1" /><span>Next Availability :</span> 10 May 2024
              </li>
              <li>
                <i className="isax isax-location5 me-1" /><span>Location :</span> Las Vegas, USA
              </li>
            </ul>
            <div className="last-book">
              <p>Last Book on 08 Mar 2023</p>
            </div>
          </div>
        </div>
        <div className="fav-footer">
          <div className="row row-sm">
            <div className="col-6">
              <a href="/" className="btn btn-md btn-light w-100">View Profile</a>
            </div>
            <div className="col-6">
              <a href="/" className="btn btn-md btn-outline-primary w-100">Book Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-6 col-lg-4 d-flex">
      <div className="profile-widget patient-favour flex-fill">
        <div className="fav-head">
          {/* <a> */}<a href="#!"  className="fav-btn favourite-btn">
            <span className="favourite-icon favourite"><i className="isax isax-heart5" /></span>
          </a>
          <div className="doc-img">
            <a href="/">
              <img className="img-fluid" alt="User " src="assets/img/doctors/doctor-thumb-18.jpg" />
            </a>
          </div>
          <div className="pro-content">
            <h3 className="title">
              <a href="/">Dr.Victoria Selzer</a> 
              <i className="isax isax-tick-circle5 verified" />
            </h3>
            <p className="speciality">DO - Anesthesiology</p>
            <div className="rating">
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star" />
              <span className="d-inline-block average-rating">5.0</span>
            </div>
            <ul className="available-info">
              <li>
                <i className="isax isax-calendar5 me-1" /><span>Next Availability :</span> 20 May 2024
              </li>
              <li>
                <i className="isax isax-location5 me-1" /><span>Location :</span> Denver, USA
              </li>
            </ul>
            <div className="last-book">
              <p>Last Book on 18 Mar 2023</p>
            </div>
          </div>
        </div>
        <div className="fav-footer">
          <div className="row row-sm">
            <div className="col-6">
              <a href="/" className="btn btn-md btn-light w-100">View Profile</a>
            </div>
            <div className="col-6">
              <a href="/" className="btn btn-md btn-outline-primary w-100">Book Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-6 col-lg-4 d-flex">
      <div className="profile-widget patient-favour flex-fill">
        <div className="fav-head">
          {/* <a> */}<a href="#!"  className="fav-btn favourite-btn">
            <span className="favourite-icon favourite"><i className="isax isax-heart5" /></span>
          </a>
          <div className="doc-img">
            <a href="/">
              <img className="img-fluid" alt="User" src="assets/img/doctors/doctor-thumb-19.jpg" />
            </a>
          </div>
          <div className="pro-content">
            <h3 className="title">
              <a href="doctor-profile.html">Dr.Benjamin Hedge</a> 
              <i className="isax isax-tick-circle5 verified" />
            </h3>
            <p className="speciality">DO - Endocrinology</p>
            <div className="rating">
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star" />
              <span className="d-inline-block average-rating">4.0</span>
            </div>
            <ul className="available-info">
              <li>
                <i className="isax isax-calendar5 me-1" /><span>Next Availability :</span> 24 May 2024
              </li>
              <li>
                <i className="isax isax-location5 me-1" /><span>Location :</span> Miami, USA
              </li>
            </ul>
            <div className="last-book">
              <p>Last Book on 21 Mar 2023</p>
            </div>
          </div>
        </div>
        <div className="fav-footer">
          <div className="row row-sm">
            <div className="col-6">
              <a href="/" className="btn btn-md btn-light w-100">View Profile</a>
            </div>
            <div className="col-6">
              <a href="/" className="btn btn-md btn-outline-primary w-100">Book Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-md-6 col-lg-4 d-flex">
      <div className="profile-widget patient-favour flex-fill">
        <div className="fav-head">
          {/* <a> */}<a href="#!"  className="fav-btn favourite-btn">
            <span className="favourite-icon favourite"><i className="isax isax-heart5" /></span>
          </a>
          <div className="doc-img">
            <a href="doctor-profile.html">
              <img className="img-fluid" alt="User" src="assets/img/doctors/doctor-thumb-20.jpg" />
            </a>
          </div>
          <div className="pro-content">
            <h3 className="title">
              <a href="doctor-profile.html">Dr.Kristina Lepley</a> 
              <i className="isax isax-tick-circle5 verified" />
            </h3>
            <p className="speciality">MD - Urology</p>
            <div className="rating">
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star filled" />
              <i className="fas fa-star" />
              <span className="d-inline-block average-rating">5.0</span>
            </div>
            <ul className="available-info">
              <li>
                <i className="isax isax-calendar5 me-1" /><span>Next Availability :</span> 13 Jun 2024
              </li>
              <li>
                <i className="isax isax-location5 me-1" /><span>Location :</span> San Jose, USA
              </li>
            </ul>
            <div className="last-book">
              <p>Last Book on 10 Apr 2023</p>
            </div>
          </div>
        </div>
        <div className="fav-footer">
          <div className="row row-sm">
            <div className="col-6">
              <a href="/" className="btn btn-md btn-light w-100">View Profile</a>
            </div>
            <div className="col-6">
              <a href="/" className="btn btn-md btn-outline-primary w-100">Book Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>								
  </div>
  {/* /Favourites */}
  <div className="col-md-12">
    <div className="loader-item text-center mt-0">
      {/* <a> */}<button  className="btn btn-outline-primary rounded-pill">Load More</button>
    </div>
  </div>	
</div>

    )
}
export default Favourites;